import {defineStore} from 'pinia'
import {menuItems} from '@/data/menu'

export const useMenuStore = () => {
    // 호출할 때마다 data folder 에서 조회
    const initStore = (store) => {
        store.menuData = structuredClone(menuItems.data)
    }

    const createMenuStore = defineStore('MenuStore', {
        state: () => ({
            menuData: menuItems.data,
            userAuth: null
        }),
        getters: {
            menuItems() {
                // console.log('getter menuItems()')
                // console.log(this.userAuth)
                // console.log(this.menuData)

                return this.menuData.filter(m => {
                    if (this.userAuth === 'ROLE_ROOT' || this.userAuth === 'ROLE_ADMIN') {
                        return m.accessGroup === 'ADMIN'
                    } else if (this.userAuth === 'ROLE_BRANCH' || this.userAuth === 'ROLE_ENGINEER') {
                        return  m.accessGroup === 'BRANCH'
                    } else if (this.userAuth === 'ROLE_SUPPLIER') {
                        return  m.accessGroup === 'SELLER'
                    }

                    // else return true
                })
            }
        },
        actions: {
            applyUserAuth(userAuth) {
                this.userAuth = userAuth
            }
        }
    })

    const MenuStore = createMenuStore()
    initStore(MenuStore)
    return MenuStore
}